import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { BatchCreationResult, CreateProcessBatchPayload } from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'
import { useCallback, useState } from 'react'

export const useCreateProcessesBatch = () => {
    const useCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseCreateProcessesBatch
    )
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const createBatch = useCallback(
        async (
            payload: CreateProcessBatchPayload
        ): Promise<BatchCreationResult | null> => {
            setLoading(true)
            setError(null)
            try {
                return await useCase.execute(payload)
            } catch (e: any) {
                console.error(e)
                setError(e?.response?.data?.message ?? 'Erro ao criar os processos')
                return null
            } finally {
                setLoading(false)
            }
        },
        [useCase]
    )

    return { createBatch, loading, error }
}
